import * as React from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CustomizedSnackbar({ 
    stackOpen, 
    message, 
    setStackOpen, 
    handleStackClose ,
    messageType
}) {

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setStackOpen(false);
  };

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar 
            open={stackOpen} 
            autoHideDuration={6000} 
            onClose={handleStackClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
        <Alert onClose={handleClose} severity={messageType} sx={{ width: '100%' }}>
          { message }
        </Alert>
      </Snackbar>
    </Stack>
  );
}


